export default __webpack_public_path__ + "media/images/steps/right-side-trail-4bffa6752c5d13cdf7dcac20f616c81f.svg";